import React from 'react';
import { Box } from '@mui/material';
import CustomYearDatePicker from '../Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import CustomMonthDatePicker from '../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js'; // For range mode
import CustomDatePicker from '../Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';
import { XtramButton } from '../Widgets/XtramModal/XtramModal';
import bankXtramStyles from '../BankMatching/BankXtram.module.scss';
import headerStyles from '../ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import './dateFilter.css'; // See CSS below

const DateFilterBar = ({
  t,
  direction,
  fetchType,
  isMatchDate,
  isRange,
  filterByDocumentDate = false,
  startDate,
  endDate,
  handleEndDateChangeNew,
  handleStartDateChangeNew,
  handleRangeChange,
  handleRangeSet,
  handleDateBasisChange,
  inline = false,
}) => {
  // Inline bars sit next to the card/currency pickers, so match their 8px corners.
  const pickerRadius = inline ? '8px' : undefined;

  return (
    <div
      className={`searchFilter-bar__container ${direction}${inline ? ' date-filter-inline' : ''}`}
      style={inline ? undefined : { marginBottom: '10px' }}
    >
      {fetchType === 'Matched' ? (
        <div className="date-toggle-group">
          <div style={{ width: "160px", minWidth: "0" }}>
          <CustomYearDatePicker
            date={endDate}
            onDateChange={(newYear) => handleEndDateChangeNew(newYear, false)}
            label={t("Year")}
            height="40px"
            borderRadius={pickerRadius}
          />
          </div>
          <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
            <span>{t(isMatchDate ? 'MatchDate' : 'Document Date')}</span>
            <input
              type="checkbox"
              checked={isMatchDate}
              onChange={(e) => handleRangeChange(e, e.target.checked)}
            />
            <span className={headerStyles.switchTrack} aria-hidden="true" />
          </label>
        </div>
      ) : (
        <div className="date-toggle-group">
          {isRange && filterByDocumentDate ? (
            <>
            <div style={{ width: "160px", minWidth: "0" }}>
              <CustomDatePicker
                onDateChange={(date) => date && handleStartDateChangeNew(date, true)}
                date={startDate}
                label={t('StartDate')}
                height="40px"
              />
              </div>
              <div style={{ width: "160px", minWidth: "0" }}>
              <CustomDatePicker
                onDateChange={(date) => date && handleEndDateChangeNew(date, true)}
                date={endDate}
                label={t('EndDate')}
                height="40px"
              />
              </div>
            </>
          ) : isRange ? (
            <>
            <div style={{ width: "160px", minWidth: "0" }}>
              <CustomMonthDatePicker
                onDateChange={(date) => handleStartDateChangeNew(date, true)}
                date={startDate}
                label={t('StartDate')}
                height="40px"
                borderRadius={pickerRadius}
              />
              </div>
              <div style={{ width: "160px", minWidth: "0" }}>
              <CustomMonthDatePicker
                onDateChange={(date) => handleEndDateChangeNew(date, true)}
                date={endDate}
                label={t('EndDate')}
                height="40px"
                borderRadius={pickerRadius}
              />
              </div>
            </>
          ) : (
            <div style={{ width: "160px", minWidth: "0" }}>
            <CustomYearDatePicker
              onDateChange={(date) => handleEndDateChangeNew(date)}
              date={endDate}
              label={t("Year")}
              borderRadius={pickerRadius}
            />
            </div>
          )}
          <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
            <span>{t('DateRange')}</span>
            <input
              type="checkbox"
              checked={isRange}
              onChange={(e) => handleRangeSet(e.target.checked)}
            />
            <span className={headerStyles.switchTrack} aria-hidden="true" />
          </label>
          {typeof handleDateBasisChange === 'function' && (
            <Box className="document-data-view" dir={direction}>
              <span className="document-data-view__label">{t('DataView')}</span>
              <div className={bankXtramStyles.segmented}>
                <XtramButton
                  variant="ghost"
                  small
                  active={filterByDocumentDate}
                  aria-label="document date"
                  onClick={() => !filterByDocumentDate && handleDateBasisChange(true)}
                >
                  {t('DocumentDate')}
                </XtramButton>
                <XtramButton
                  variant="ghost"
                  small
                  active={!filterByDocumentDate}
                  aria-label="registration month"
                  onClick={() => filterByDocumentDate && handleDateBasisChange(false)}
                >
                  {t('RegistrationMonth')}
                </XtramButton>
              </div>
            </Box>
          )}
        </div>
      )}
    </div>
  );
};

export default DateFilterBar;
